import React, { FC, useEffect, useState } from 'react';
import {
    Grid, View, IllustratedMessage, ProgressBar
} from '@adobe/react-spectrum';

import '~/Assets/main.sass';
import { Canvas } from '../../Pages/Studio/Canvas';
import { createProject } from '~/Services/Studio/studioSceneBuilder';
import { LOCAL_JSON } from '~/Services/Environment/devConfig';
import Comments from './comments';
import { CommentHeader } from './header';
import { getRandomString } from '~/Utils/math';
import { IComment } from '~/Scene/Ui/uiComments';

const today = new Date();
const yesterday = new Date();
yesterday.setDate(today.getDate() - 1);

const beforeYesterday = new Date();
beforeYesterday.setDate(today.getDate() - 3);

const cuirAgneau: IComment = {
    id: getRandomString(),
    author: 'Amy',
    date: yesterday,
    point: { x: 0.1335, y: 0.9615, z: 0.2190 },
    text: 'The blue should be lighter',
};
const size: IComment = {
    id: getRandomString(),
    author: 'Jack',
    date: beforeYesterday,
    point: { x: 0.1109, y: 0.2326, z: 0.3386 },
    text: 'The pedal is supposed to be lower by 1 cm',
};
export const commentsStored = [cuirAgneau, size];

const CommentLayout: FC = () => {
    const [loading, setLoading] = useState(true);
    const [comments, setComments] = useState<IComment[]>(commentsStored);
    const areas = [
        'header header',
        'center right'
    ];
    const columns = ['auto', 'size-3600'];
    const rows = ['size-800', 'auto'];

    useEffect(() => {
        createProject(LOCAL_JSON, () => {
            setLoading(false);
        });
    }, []);

    const refresh = () => {
        commentsStored.pop();
        commentsStored.pop();
        setComments([...commentsStored]);
    };

    return (
        <>
            {loading
                && (
                    <View backgroundColor="gray-200" height="100vh">
                        <IllustratedMessage>
                            <ProgressBar
                                label="Loading"
                                size="L"
                                isIndeterminate
                            />
                        </IllustratedMessage>
                    </View>
                )}
            <Grid
                areas={areas}
                columns={columns}
                rows={rows}
                height="100vh"
            >
                <View gridArea="header">
                    <CommentHeader onLoad={refresh} />
                </View>
                <View gridArea="center" UNSAFE_style={{ background: 'white' }}>
                    <Canvas />
                </View>
                <View gridArea="right" padding="size-200">
                    <Comments engineComments={comments} />
                </View>
            </Grid>
        </>
    );
};

export default CommentLayout;
